(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["letnie-bestsellery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('letnie-bestsellery')) {
    class LetnieBestsellery extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-lb-track]');
        if (!this.track) return;
        this.prevBtn = this.querySelector('[data-lb-prev]');
        this.nextBtn = this.querySelector('[data-lb-next]');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this._ac = new AbortController();
        const signal = this._ac.signal;

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this._scroll(-1), { signal });
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this._scroll(1), { signal });

        this._initDrag(signal);
        this._initTouchScale(signal);

        const onScroll = () => window.requestAnimationFrame(() => this._updateArrows());
        this.track.addEventListener('scroll', onScroll, { passive: true, signal });
        window.addEventListener('resize', onScroll, { passive: true, signal });
        this._updateArrows();

        if (window.Shopify && window.Shopify.designMode) {
          this.addEventListener('shopify:block:select', (e) => {
            const card = (e.target.closest && e.target.closest('[data-lb-card]')) || e.target;
            if (card && card.scrollIntoView) {
              card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
            }
          }, { signal });
        }
      }

      disconnectedCallback() {
        if (this._ac) this._ac.abort();
      }

      _step() {
        const card = this.track.querySelector('.lb__card');
        if (!card) return this.track.clientWidth * 0.8;
        const cs = getComputedStyle(this.track);
        const gap = parseFloat(cs.columnGap || cs.gap) || 24;
        return card.getBoundingClientRect().width + gap;
      }

      _scroll(dir) {
        this.track.scrollBy({ left: dir * this._step(), behavior: this.reduceMotion ? 'auto' : 'smooth' });
      }

      _updateArrows() {
        const max = this.track.scrollWidth - this.track.clientWidth - 1;
        const x = this.track.scrollLeft;
        if (this.prevBtn) this.prevBtn.toggleAttribute('disabled', x <= 0);
        if (this.nextBtn) this.nextBtn.toggleAttribute('disabled', x >= max);
      }

      _initDrag(signal) {
        const track = this.track;
        let down = false, startX = 0, startScroll = 0, dragged = false;
        track.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'touch') return;               // dotyk = natywne przewijanie; taps pozostają klikalne
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          down = true; dragged = false;
          startX = e.pageX; startScroll = track.scrollLeft;
        }, { signal });
        window.addEventListener('pointermove', (e) => {
          if (!down) return;
          const dx = e.pageX - startX;
          // Klasę is-dragging (pointer-events:none na linkach) dodajemy DOPIERO po realnym przeciągnięciu.
          // Dodanie jej już przy pointerdown sprawiało, że hit-test „przelatywał" przez link do karty pod
          // spodem i zwykłe kliknięcie w produkt nie nawigowało.
          if (!dragged && Math.abs(dx) > 8) {
            dragged = true;
            track.classList.add('is-dragging');
          }
          if (dragged) track.scrollLeft = startScroll - dx;
        }, { passive: true, signal });
        const up = () => {
          if (!down) return;
          down = false;
          track.classList.remove('is-dragging');
        };
        window.addEventListener('pointerup', up, { signal });
        window.addEventListener('pointercancel', up, { signal });
        // Po realnym przeciągnięciu anuluj tylko nawigację linków — przyciski (koszyk) przechodzą.
        track.addEventListener('click', (e) => {
          if (dragged && e.target.closest && e.target.closest('a')) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, { capture: true, signal });
      }

      _initTouchScale(signal) {
        if (this.reduceMotion) return;
        if (!window.matchMedia('(hover: none)').matches) return;
        const track = this.track;
        const cards = track.querySelectorAll('.lb__card');
        if (!cards.length) return;
        const peak = parseFloat(getComputedStyle(this).getPropertyValue('--lb-hover-scale')) || 1.06;
        if (peak <= 1.001) return; // powiekszenie 0% -> bez petli skalowania (oszczedza scroll na mobile)
        let ticking = false;
        const run = () => {
          ticking = false;
          const rect = track.getBoundingClientRect();
          const centre = rect.left + rect.width / 2;
          // Faza odczytu: zbierz wszystkie pomiary przed jakimkolwiek zapisem (bez layout thrashing).
          const ts = [];
          cards.forEach((c) => {
            const cr = c.getBoundingClientRect();
            const cc = cr.left + cr.width / 2;
            const dist = Math.abs(cc - centre);
            ts.push(Math.max(0, 1 - dist / (rect.width / 1.6)));
          });
          // Faza zapisu.
          cards.forEach((c, i) => {
            const t = ts[i];
            c.style.setProperty('--lb-card-scale', (1 + t * (peak - 1)).toFixed(3));
            c.classList.toggle('is-focused', t > 0.6);
          });
        };
        const schedule = () => {
          if (!ticking) { ticking = true; window.requestAnimationFrame(run); }
        };
        track.addEventListener('scroll', schedule, { passive: true, signal });
        window.addEventListener('resize', schedule, { passive: true, signal });
        requestAnimationFrame(run);
      }
    }
    customElements.define('letnie-bestsellery', LetnieBestsellery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zwroty-formularz"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var root = document.getElementById('vz-root');
  if (!root || root.dataset.vzInit) return;
  root.dataset.vzInit = '1';

  var CFG = {};
  try { CFG = JSON.parse(document.getElementById('vz-config').textContent); } catch (e) {}
  var API = (CFG.apiBase || '').replace(/\/$/, '');
  var WINDOW_DAYS = CFG.windowDays || 21;
  var STATUTORY = CFG.statutoryDays || 14;

  var REASONS = [
    { value: '', label: 'Wybierz powód…' },
    { value: 'size', label: 'Zły rozmiar' },
    { value: 'expect', label: 'Produkt nie spełnia oczekiwań' },
    { value: 'defect', label: 'Produkt wadliwy / uszkodzony' },
    { value: 'wrong', label: 'Otrzymano niewłaściwy produkt' },
    { value: 'mind', label: 'Zmiana decyzji (odstąpienie od umowy)' },
    { value: 'other', label: 'Inny powód' }
  ];
  // Wybór sposobu wysyłki usunięty — klient zawsze odsyła paczkę we własnym zakresie, na własny koszt.
  var REFUND_DEFS = [
    { id: 'original', title: 'Zwrot na pierwotną formę płatności', desc: 'Środki wrócą tam, skąd opłacono zamówienie' },
    { id: 'bank', title: 'Przelew na konto bankowe', desc: 'Wskaż numer konta, na które mamy zwrócić środki' }
  ];

  var state = {
    step: 'lookup', mode: 'return',
    email: '', orderNumber: '', error: '', loading: false,
    orderToken: '', orderName: '', deliveredDate: '', returnAddress: '',
    items: [], ship: 'wlasna', refund: 'original', iban: '',
    cancelScope: 'items', cancelReason: '', consent: false,
    manualRefund: false, paymentLabel: '', accountName: '',
    resultNumber: ''
  };

  var stepperEl = document.getElementById('vz-stepper');
  var mainEl = document.getElementById('vz-main');
  var lastStep = null;

  function zl(n) { return Number(n).toFixed(2).replace('.', ',') + ' zł'; }
  function initials(name) {
    return String(name).replace(/[„"]/g, '').trim().split(/\s+/).slice(0, 2)
      .map(function (w) { return w[0] || ''; }).join('').toUpperCase();
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function stepsForMode() {
    return state.mode === 'cancel'
      ? [{ k: 'lookup', l: 'Dane' }, { k: 'select', l: 'Pozycje' }, { k: 'done', l: 'Gotowe' }]
      : [{ k: 'lookup', l: 'Dane' }, { k: 'select', l: 'Produkty' }, { k: 'method', l: 'Zwrot' }, { k: 'done', l: 'Gotowe' }];
  }
  function renderStepper() {
    if (state.step === 'done') { stepperEl.innerHTML = ''; return; }
    var defs = stepsForMode();
    var idx = defs.map(function (d) { return d.k; }).indexOf(state.step);
    var html = '';
    for (var i = 0; i < defs.length; i++) {
      var done = i < idx, active = i === idx, on = done || active, grow = i < defs.length - 1 ? ' grow' : '';
      html += '<div class="vz-step-node' + grow + '"><div class="vz-step-col">'
        + '<div class="vz-dot' + (on ? ' on' : '') + '">' + (done ? '✓' : (i + 1)) + '</div>'
        + '<span class="vz-step-label' + (active ? ' on' : '') + '">' + defs[i].l + '</span></div>';
      if (i < defs.length - 1) html += '<div class="vz-bar' + (i < idx ? ' fill' : '') + '"></div>';
      html += '</div>';
    }
    stepperEl.innerHTML = html;
  }

  function errorRow() {
    return state.error ? '<div class="vz-error-row" id="vz-err"><span class="vz-error-badge">!</span>' + esc(state.error) + '</div>' : '';
  }
  function primaryBtn(label, id) {
    return '<button class="vz-btn" id="' + (id || 'vz-go') + '">' + (state.loading ? '<span class="vz-spinner"></span>' : '<span>' + label + '</span>') + '</button>';
  }
  function thumbHtml(it) {
    return it.image
      ? '<div class="vz-thumb"><img src="' + esc(it.image) + '" alt="" loading="lazy"></div>'
      : '<div class="vz-thumb">' + esc(initials(it.name)) + '</div>';
  }

  /* ---------- STEP: lookup ---------- */
  function viewLookup() {
    return '<h2 class="vz-h">Zwrot lub anulowanie zamówienia</h2>'
      + '<p class="vz-lead vz-lead--tight">Masz <strong>' + WINDOW_DAYS + ' dni</strong> od otrzymania przesyłki, aby odstąpić od umowy — bez podawania przyczyny.</p>'
      + '<p class="vz-lead vz-lead--cta">Wypełnij poniższy formularz, podając adres e-mail i numer zamówienia.</p>'
      + '<label class="vz-field-label">Adres e-mail</label>'
      + '<input type="email" id="vz-email" class="vz-uline" placeholder="jan.kowalski@email.com" autocomplete="email" inputmode="email">'
      + '<label class="vz-field-label gap">Numer zamówienia</label>'
      + '<input type="text" id="vz-order" class="vz-uline" placeholder="np. #32150282" autocomplete="off">'
      + errorRow()
      + primaryBtn('Dalej&nbsp;&nbsp;→');
  }
  function wireLookup() {
    var email = document.getElementById('vz-email'), order = document.getElementById('vz-order');
    email.value = state.email; email.classList.toggle('active', !!state.email);
    order.value = state.orderNumber; order.classList.toggle('active', !!state.orderNumber);
    email.oninput = function () { state.email = email.value; email.classList.toggle('active', !!email.value); clearErr(); };
    order.oninput = function () { state.orderNumber = order.value; order.classList.toggle('active', !!order.value); clearErr(); };
    document.getElementById('vz-go').onclick = doLookup;
  }

  /* ---------- STEP: select (return) ---------- */
  function viewSelectReturn() {
    var rows = state.items.map(function (it) {
      var opts = REASONS.map(function (r) { return '<option value="' + r.value + '"' + (r.value === it.reason ? ' selected' : '') + '>' + esc(r.label) + '</option>'; }).join('');
      var reason = it.checked ? '<div class="vz-reason"><label class="vz-reason-label">Powód zwrotu</label><select class="vz-select" data-reason="' + esc(it.id) + '">' + opts + '</select></div>' : '';
      return '<div class="vz-card' + (it.checked ? ' checked' : '') + '"><div class="vz-row">'
        + '<div class="vz-check' + (it.checked ? ' checked' : '') + '" data-toggle="' + esc(it.id) + '">' + (it.checked ? '✓' : '') + '</div>'
        + thumbHtml(it)
        + '<div class="vz-info"><div class="vz-name">' + esc(it.name) + '</div><div class="vz-variant">' + esc(it.variant) + '</div><div class="vz-price">' + esc(it.priceLabel || zl(it.price)) + '</div></div>'
        + '</div>' + reason + '</div>';
    }).join('');
    return '<button class="vz-back" id="vz-back">←&nbsp;&nbsp;Wstecz</button>'
      + '<h2 class="vz-h">Wybierz produkty do zwrotu</h2>'
      + '<div class="vz-meta"><span>Zamówienie <b>' + esc(state.orderName) + '</b></span>'
      + '<span class="ok">✓ W terminie zwrotu (' + WINDOW_DAYS + ' dni)</span></div>'
      + '<div class="vz-items">' + rows + '</div>'
      + errorRow()
      + primaryBtn('Dalej&nbsp;&nbsp;→');
  }

  /* ---------- STEP: select (cancel) ---------- */
  function viewSelectCancel() {
    var whole = state.cancelScope === 'whole';
    var rows = state.items.map(function (it) {
      return '<div class="vz-card' + (it.checked && !whole ? ' checked' : '') + '"' + (whole ? ' style="opacity:.5"' : '') + '><div class="vz-row">'
        + '<div class="vz-check' + (it.checked && !whole ? ' checked' : '') + '" data-toggle="' + esc(it.id) + '">' + (it.checked && !whole ? '✓' : '') + '</div>'
        + thumbHtml(it)
        + '<div class="vz-info"><div class="vz-name">' + esc(it.name) + '</div><div class="vz-variant">' + esc(it.variant) + '</div><div class="vz-price">' + esc(it.priceLabel || zl(it.price)) + '</div></div>'
        + '</div></div>';
    }).join('');
    return '<button class="vz-back" id="vz-back">←&nbsp;&nbsp;Wstecz</button>'
      + '<h2 class="vz-h">Anuluj lub zmień zamówienie</h2>'
      + '<p class="vz-lead">Zamówienie <b>' + esc(state.orderName) + '</b> nie zostało jeszcze zrealizowane, więc możesz usunąć wybrane pozycje albo anulować je w całości. '
      + (state.manualRefund
          ? 'Zmianę wprowadzimy od razu.'
          : 'Zmianę wprowadzimy od razu, a środki za anulowane pozycje wrócą automatycznie na Twoją pierwotną metodę płatności.')
      + '</p>'
      + '<div class="vz-opts" style="margin-bottom:20px">'
      + '<div class="vz-opt' + (!whole ? ' selected' : '') + '" data-scope="items"><div class="vz-radio' + (!whole ? ' selected' : '') + '"></div><div class="vz-opt-body"><div class="vz-opt-title">Usuń wybrane pozycje</div><div class="vz-opt-desc">Zaznacz produkty do usunięcia z zamówienia</div></div></div>'
      + '<div class="vz-opt' + (whole ? ' selected' : '') + '" data-scope="whole"><div class="vz-radio' + (whole ? ' selected' : '') + '"></div><div class="vz-opt-body"><div class="vz-opt-title">Anuluj całe zamówienie</div><div class="vz-opt-desc">Wszystkie pozycje zostaną zgłoszone do anulowania</div></div></div>'
      + '</div>'
      + '<div class="vz-items">' + rows + '</div>'
      + (state.manualRefund
          ? '<div class="vz-bank">'
            + '<label class="vz-field-label">Numer rachunku do zwrotu</label>'
            + '<input type="text" id="vz-iban" class="vz-uline" placeholder="PL00 0000 0000 0000 0000 0000 0000" inputmode="numeric" autocomplete="off">'
            + '<label class="vz-field-label gap">Właściciel rachunku (imię i nazwisko)</label>'
            + '<input type="text" id="vz-acc-name" class="vz-uline" placeholder="Jan Kowalski" autocomplete="name">'
            + '</div>'
          : '')
      + '<label class="vz-field-label gap">Powód (opcjonalnie)</label>'
      + '<input type="text" id="vz-cancel-reason" class="vz-uline" placeholder="np. pomyłka w rozmiarze">'
      + consentHtml('Oświadczam, że chcę anulować wskazane pozycje / całe zamówienie przed jego realizacją.')
      + errorRow()
      + primaryBtn('Wyślij zgłoszenie');
  }

  /* ---------- STEP: method (return only) ---------- */
  function optHtml(o, selected, kind, showCost) {
    return '<div class="vz-opt' + (selected ? ' selected' : '') + '" data-' + kind + '="' + esc(o.id) + '"><div class="vz-radio' + (selected ? ' selected' : '') + '"></div>'
      + '<div class="vz-opt-body"><div class="vz-opt-title">' + esc(o.title) + '</div><div class="vz-opt-desc">' + esc(o.desc) + '</div></div>'
      + (showCost && o.cost ? '<div class="vz-opt-cost">' + esc(o.cost) + '</div>' : '') + '</div>';
  }
  function consentHtml(text) {
    return '<label class="vz-consent"><input type="checkbox" id="vz-consent"' + (state.consent ? ' checked' : '') + '><span>' + esc(text) + '</span></label>';
  }
  function viewMethod() {
    var chosen = state.items.filter(function (it) { return it.checked; });
    var total = chosen.reduce(function (a, it) { return a + Number(it.price || 0); }, 0);
    var sum = chosen.map(function (it) { return '<div class="vz-summary-row"><span>' + esc(it.name) + '</span><span>' + esc(it.priceLabel || zl(it.price)) + '</span></div>'; }).join('');
    var refund = REFUND_DEFS.map(function (o) { return optHtml(o, state.refund === o.id, 'refund', false); }).join('');
    var iban = state.refund === 'bank' ? '<div style="margin:8px 0 4px"><label class="vz-field-label">Numer konta bankowego (IBAN)</label><input type="text" id="vz-iban" class="vz-uline" placeholder="PL00 0000 0000 0000 0000 0000 0000" inputmode="numeric"></div>' : '';
    return '<button class="vz-back" id="vz-back">←&nbsp;&nbsp;Wstecz</button>'
      + '<h2 class="vz-h" style="margin-bottom:18px">Zwrot środków</h2>'
      + '<div class="vz-legal">Zwracany towar odsyłasz <strong>we własnym zakresie i na własny koszt</strong>.</div>'
      + '<h3 class="vz-h3" style="margin-top:24px">Forma zwrotu środków</h3><div class="vz-opts" style="margin-bottom:18px">' + refund + '</div>' + iban
      + '<div class="vz-summary"><div class="vz-summary-title">Podsumowanie zwrotu</div>' + sum + '<div class="vz-summary-total"><span>Wartość produktów</span><span>' + zl(total) + '</span></div></div>'
      + consentHtml('Oświadczam, że odstępuję od umowy sprzedaży zaznaczonych produktów / zgłaszam ich zwrot.')
      + errorRow()
      + primaryBtn('Potwierdź zwrot');
  }

  /* ---------- STEP: done ---------- */
  function viewDone() {
    var isCancel = state.mode === 'cancel';
    var box;
    if (isCancel) {
      box = '<div class="vz-done-box"><div class="vz-done-head"><span class="lbl">Numer zgłoszenia</span><span class="num">' + esc(state.resultNumber) + '</span></div>'
        + '<div class="vz-steps">'
        + '<div class="vz-step2"><span class="n">1</span><span class="t">Wprowadziliśmy zmianę w zamówieniu (usunięcie wskazanych pozycji lub anulowanie całości).</span></div>'
        + '<div class="vz-step2"><span class="n">2</span><span class="t">' + (state.manualRefund
            ? 'Środki za anulowane pozycje zwrócimy <b>przelewem na wskazane konto</b> w ciągu 14 dni; potwierdzenie wysłaliśmy na <b>' + esc(state.email) + '</b>.'
            : 'Środki za anulowane pozycje wracają na Twoją pierwotną metodę płatności; potwierdzenie wysłaliśmy na <b>' + esc(state.email) + '</b>.') + '</span></div>'
        + '</div></div>';
    } else {
      var addr = state.returnAddress
        ? '<div class="vz-addr">' + esc(state.returnAddress) + '</div>'
        : '';
      box = '<div class="vz-done-box"><div class="vz-done-head"><span class="lbl">Numer zwrotu</span><span class="num">' + esc(state.resultNumber) + '</span></div>'
        + '<div class="vz-steps">'
        + '<div class="vz-step2"><span class="n">1</span><span class="t">Zapakuj produkty i odeślij na adres zwrotu poniżej.</span></div>'
        + '<div class="vz-step2"><span class="n">2</span><span class="t">Dołącz numer zwrotu <b>' + esc(state.resultNumber) + '</b> do przesyłki.</span></div>'
        + '<div class="vz-step2"><span class="n">3</span><span class="t">Zwrot środków nastąpi do 14 dni od otrzymania przesyłki.</span></div>'
        + '</div>' + addr + '</div>';
    }
    return '<div class="vz-done">'
      + '<div class="vz-done-circle"><svg width="30" height="30" viewBox="0 0 24 24" fill="none"><path d="M5 12.5 L10 17.5 L19 7" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></div>'
      + '<h2>' + (isCancel ? 'Zamówienie zaktualizowane' : 'Zwrot został zgłoszony') + '</h2>'
      + '<p class="vz-done-p">Potwierdzenie wysłaliśmy na adres <b>' + esc(state.email) + '</b>.</p>'
      + box
      + '<div class="vz-done-actions">'
      + (isCancel ? '' : '<button class="vz-btn-dark" id="vz-print">Drukuj potwierdzenie</button>')
      + '<button class="vz-btn-light" id="vz-reset">Nowe zgłoszenie</button></div>'
      + '</div>';
  }

  /* ---------- render ---------- */
  function render() {
    renderStepper();
    var view = state.step === 'lookup' ? viewLookup
      : state.step === 'select' ? (state.mode === 'cancel' ? viewSelectCancel : viewSelectReturn)
      : state.step === 'method' ? viewMethod : viewDone;
    var animate = state.step !== lastStep;
    mainEl.innerHTML = '<div class="' + (animate ? 'vz-fade' : '') + '">' + view() + '</div>';
    wire();
    lastStep = state.step;
  }
  function clearErr() { if (state.error) { state.error = ''; var e = document.getElementById('vz-err'); if (e) e.remove(); } }

  function wire() {
    var back = document.getElementById('vz-back');
    if (back) back.onclick = function () { state.error = ''; state.step = (state.step === 'method' ? 'select' : 'lookup'); render(); };
    var go = document.getElementById('vz-go');

    if (state.step === 'lookup') { wireLookup(); return; }

    if (state.step === 'select' && state.mode === 'return') {
      bindToggles(); bindReasons(); if (go) go.onclick = goMethod; return;
    }
    if (state.step === 'select' && state.mode === 'cancel') {
      bindToggles();
      forEach('[data-scope]', function (el) { el.onclick = function () { state.cancelScope = el.getAttribute('data-scope'); state.error = ''; render(); }; });
      var cr = document.getElementById('vz-cancel-reason'); if (cr) { cr.value = state.cancelReason; cr.oninput = function () { state.cancelReason = cr.value; }; }
      var cib = document.getElementById('vz-iban'); if (cib) { cib.value = state.iban; cib.oninput = function () { state.iban = cib.value; clearErr(); }; }
      var can = document.getElementById('vz-acc-name'); if (can) { can.value = state.accountName; can.oninput = function () { state.accountName = can.value; clearErr(); }; }
      bindConsent(); if (go) go.onclick = submitCancel; return;
    }
    if (state.step === 'method') {
      forEach('[data-refund]', function (el) { el.onclick = function () { state.refund = el.getAttribute('data-refund'); state.error = ''; render(); }; });
      var ib = document.getElementById('vz-iban'); if (ib) { ib.value = state.iban; ib.oninput = function () { state.iban = ib.value; clearErr(); }; }
      bindConsent(); if (go) go.onclick = submitReturn; return;
    }
    if (state.step === 'done') {
      var p = document.getElementById('vz-print'); if (p) p.onclick = printReturn;
      var r = document.getElementById('vz-reset'); if (r) r.onclick = reset;
    }
  }
  function forEach(sel, fn) { Array.prototype.forEach.call(mainEl.querySelectorAll(sel), fn); }
  function bindToggles() { forEach('[data-toggle]', function (el) { el.onclick = function () { toggleItem(el.getAttribute('data-toggle')); }; }); }
  function bindReasons() { forEach('[data-reason]', function (el) { el.onchange = function () { setReason(el.getAttribute('data-reason'), el.value); }; }); }
  function bindConsent() { var c = document.getElementById('vz-consent'); if (c) c.onchange = function () { state.consent = c.checked; clearErr(); }; }

  function toggleItem(id) {
    state.error = '';
    state.items = state.items.map(function (it) { return it.id === id ? Object.assign({}, it, { checked: !it.checked }) : it; });
    render();
  }
  function setReason(id, v) { state.items = state.items.map(function (it) { return it.id === id ? Object.assign({}, it, { reason: v }) : it; }); }

  /* ---------- logic ---------- */
  function doLookup() {
    if (state.loading) return;
    var email = state.email.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { state.error = 'Podaj poprawny adres e-mail.'; return render(); }
    if (!state.orderNumber.trim()) { state.error = 'Podaj numer zamówienia.'; return render(); }
    state.loading = true; state.error = ''; render();

    api('/lookup-order', { email: email, orderNumber: state.orderNumber.trim() }).then(function (r) {
      state.loading = false;
      if (r.status === 200) {
        var d = r.data;
        state.mode = d.mode || 'return';
        state.orderToken = d.orderToken || '';
        state.orderName = d.orderName || state.orderNumber.trim();
        state.deliveredDate = d.deliveredDate || '';
        state.returnAddress = d.returnAddress || '';
        state.manualRefund = !!d.manualRefund;
        state.paymentLabel = d.paymentLabel || '';
        state.accountName = '';
        state.consent = false;
        state.items = (d.items || []).map(function (it) { return Object.assign({}, it, { checked: false, reason: '' }); });
        state.step = 'select';
        return render();
      }
      state.error = (r.data && r.data.message) || 'Nie znaleźliśmy zamówienia dla podanych danych.';
      render();
    });
  }

  function goMethod() {
    var chosen = state.items.filter(function (it) { return it.checked; });
    if (!chosen.length) { state.error = 'Zaznacz przynajmniej jeden produkt do zwrotu.'; return render(); }
    if (chosen.some(function (it) { return !it.reason; })) { state.error = 'Wybierz powód zwrotu dla każdego zaznaczonego produktu.'; return render(); }
    state.error = ''; state.step = 'method'; render();
  }

  function submitReturn() {
    if (state.loading) return;
    if (state.refund === 'bank' && state.iban.replace(/\s/g, '').length < 22) { state.error = 'Podaj poprawny numer konta (IBAN).'; return render(); }
    if (!state.consent) { state.error = 'Zaznacz oświadczenie o odstąpieniu / zgłoszeniu zwrotu, aby kontynuować.'; return render(); }
    state.loading = true; state.error = ''; render();
    var items = state.items.filter(function (it) { return it.checked; }).map(function (it) { return { id: it.id, reason: it.reason, quantity: it.quantity || 1 }; });
    api('/create-return', { orderToken: state.orderToken, items: items, shipping: state.ship, refund: state.refund, iban: state.iban }).then(function (r) {
      state.loading = false;
      if (r.status === 200) { state.resultNumber = (r.data && r.data.returnNumber) || '—'; state.step = 'done'; return render(); }
      state.error = (r.data && r.data.message) || 'Nie udało się utworzyć zwrotu. Spróbuj ponownie.';
      render();
    });
  }

  function submitCancel() {
    if (state.loading) return;
    if (state.cancelScope === 'items' && !state.items.some(function (it) { return it.checked; })) { state.error = 'Zaznacz pozycje do usunięcia lub wybierz anulowanie całości.'; return render(); }
    if (state.manualRefund) {
      if (state.iban.replace(/[\s-]/g, '').length < 22) { state.error = 'Podaj numer konta (IBAN) do zwrotu.'; return render(); }
      if (!state.accountName.trim()) { state.error = 'Podaj właściciela konta (imię i nazwisko).'; return render(); }
    }
    if (!state.consent) { state.error = 'Zaznacz oświadczenie, aby wysłać zgłoszenie.'; return render(); }
    state.loading = true; state.error = ''; render();
    var items = state.items.filter(function (it) { return it.checked; }).map(function (it) { return { id: it.id, quantity: it.quantity || 1 }; });
    api('/cancel-request', { orderToken: state.orderToken, scope: state.cancelScope, items: items, reason: state.cancelReason, iban: state.iban, accountName: state.accountName }).then(function (r) {
      state.loading = false;
      if (r.status === 200) { state.resultNumber = (r.data && r.data.requestNumber) || '—'; state.step = 'done'; return render(); }
      state.error = (r.data && r.data.message) || 'Nie udało się wysłać zgłoszenia. Spróbuj ponownie.';
      render();
    });
  }

  function reasonLabel(v) {
    for (var i = 0; i < REASONS.length; i++) if (REASONS[i].value === v) return REASONS[i].label;
    return '';
  }
  // Generuje czysty dokument „Potwierdzenie zwrotu" i drukuje go (ukryty iframe — omija blokady popupów).
  function printReturn() {
    var chosen = state.items.filter(function (it) { return it.checked; });
    var today = new Date().toLocaleDateString('pl-PL', { day: 'numeric', month: 'long', year: 'numeric' });
    var total = chosen.reduce(function (a, it) { return a + Number(it.price || 0); }, 0);
    var rows = chosen.map(function (it) {
      var rl = reasonLabel(it.reason);
      return '<tr><td>' + esc(it.name)
        + (it.variant ? '<div class="v">' + esc(it.variant) + '</div>' : '')
        + (rl ? '<div class="v">Powód: ' + esc(rl) + '</div>' : '')
        + '</td><td class="r">' + esc(it.priceLabel || zl(it.price)) + '</td></tr>';
    }).join('');
    var addr = state.returnAddress
      ? '<div class="sec"><div class="lbl">Adres zwrotu</div><div class="addr">' + esc(state.returnAddress) + '</div></div>'
      : '';
    var html = '<!DOCTYPE html><html lang="pl"><head><meta charset="utf-8">'
      + '<title>Potwierdzenie zwrotu ' + esc(state.resultNumber) + '</title><style>'
      + 'body{font-family:Arial,Helvetica,sans-serif;color:#1d1d1f;margin:32px;font-size:13px;line-height:1.5}'
      + '.brand{font-size:12px;letter-spacing:.08em;text-transform:uppercase;color:#666;margin-bottom:14px}'
      + 'h1{font-size:20px;margin:0 0 16px}'
      + '.meta div{margin:3px 0}.meta b{display:inline-block;min-width:160px;color:#666;font-weight:normal}'
      + '.lbl{font-size:11px;text-transform:uppercase;letter-spacing:.05em;color:#888;margin:18px 0 6px}'
      + 'table{width:100%;border-collapse:collapse}td{padding:8px 0;border-bottom:1px solid #e6e6ea;vertical-align:top}'
      + '.v{font-size:12px;color:#666;margin-top:2px}.r{text-align:right;white-space:nowrap;padding-left:14px}'
      + '.total{display:flex;justify-content:space-between;font-weight:bold;padding-top:10px}'
      + '.addr{white-space:pre-line;border:1px dashed #bbb;border-radius:6px;padding:10px 12px;display:inline-block}'
      + 'ol{margin:6px 0 0 18px;padding:0}ol li{margin:3px 0}'
      + '@media print{body{margin:14mm}}</style></head><body>'
      + '<div class="brand">VENA Uniformy</div><h1>Potwierdzenie zwrotu</h1>'
      + '<div class="meta">'
      + '<div><b>Numer zwrotu</b>' + esc(state.resultNumber) + '</div>'
      + (state.orderName ? '<div><b>Zamówienie</b>' + esc(state.orderName) + '</div>' : '')
      + '<div><b>Data zgłoszenia</b>' + esc(today) + '</div>'
      + (state.email ? '<div><b>E-mail</b>' + esc(state.email) + '</div>' : '')
      + '</div>'
      + '<div class="lbl">Zwracane produkty</div><table>' + rows + '</table>'
      + '<div class="total"><span>Wartość produktów</span><span>' + zl(total) + '</span></div>'
      + addr
      + '<div class="sec"><div class="lbl">Co dalej</div><ol>'
      + '<li>Zapakuj produkty i odeślij na adres zwrotu.</li>'
      + '<li>Dołącz numer zwrotu <b>' + esc(state.resultNumber) + '</b> do przesyłki.</li>'
      + '<li>Zwrot środków nastąpi do 14 dni od otrzymania przesyłki.</li>'
      + '</ol></div></body></html>';
    var ifr = document.createElement('iframe');
    ifr.setAttribute('style', 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;');
    document.body.appendChild(ifr);
    var doPrint = function () {
      if (ifr._done) return; ifr._done = true;
      try { ifr.contentWindow.focus(); ifr.contentWindow.print(); } catch (e) {}
      setTimeout(function () { if (ifr.parentNode) ifr.parentNode.removeChild(ifr); }, 1500);
    };
    ifr.onload = doPrint;
    var d = ifr.contentWindow.document;
    d.open(); d.write(html); d.close();
    setTimeout(doPrint, 500);   // fallback gdy onload nie odpali
  }

  function reset() {
    state.step = 'lookup'; state.mode = 'return'; state.email = ''; state.orderNumber = ''; state.error = '';
    state.orderToken = ''; state.orderName = ''; state.items = []; state.ship = 'wlasna'; state.refund = 'original';
    state.iban = ''; state.cancelScope = 'items'; state.cancelReason = ''; state.consent = false; state.resultNumber = '';
    state.manualRefund = false; state.paymentLabel = ''; state.accountName = '';
    render();
  }

  // fetch z jednolitą obsługą; ZERO trybu demo — błąd sieci = czytelny komunikat.
  function api(path, body) {
    return fetch(API + path, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) { return { status: res.status, data: data }; });
    }).catch(function () {
      return { status: 0, data: { message: 'Brak połączenia z serwerem. Sprawdź internet i spróbuj ponownie.' } };
    });
  }

  render();
})();

  } catch(e) { console.error(e); }
})();
})();
